<template>
<div class="header" :style="{ backgroundColor: menuBarBackgroundColor}">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
        <i v-if="!collapse" class="el-icon-s-fold"></i>
        <i v-else class="el-icon-s-unfold"></i>
    </div>
    <div class="logo">{{$t('layout.header.logo')}}</div>
    <div class="header-right">
        <div class="header-user-con">
            <LanguageSwitcher />
            <!-- 全屏显示 -->
            <div class="btn-fullscreen" @click="handleFullScreen">
                <el-tooltip effect="dark" :content="fullscreen ? $t('header.tooltips.fullscreenCancel') : $t('header.tooltips.fullscreenEnter')" placement="bottom">
                    <i class="el-icon-rank"></i>
                </el-tooltip>
            </div>
            <!-- 消息中心 -->
            <div class="btn-bell">
                <el-tooltip effect="dark" :content="message ? $t('header.tooltips.bellWithCount', { count: message }) : $t('header.tooltips.bellDefault')" placement="bottom">
                    <router-link to="/tabs">
                        <i class="el-icon-bell"></i>
                    </router-link>
                </el-tooltip>
                <span class="btn-bell-badge" v-if="message"></span>
            </div>
            <!-- 用户头像 -->
            <div class="user-avator">
                <!-- <img src="../../assets/img/img.jpg" /> -->
                <img src="../../assets/img/logo.png" />
            </div>
            <!-- 用户名下拉菜单 -->
            <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                    {{ dispalayName }}
                    <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <!-- <a href="https://github.com/lin-xin/vue-manage-system" target="_blank">
                            <el-dropdown-item>项目仓库</el-dropdown-item>
                        </a> -->
                    <el-dropdown-item icon="el-icon-switch-button" divided command="loginout">{{ operateName }}</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-setting" command="setting">个人设置</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</div>
</template>

<script>
import {
    compressBatches
} from 'echarts/lib/util/model';
import router from '../../router';
import bus from '../common/bus';
import screenfull from 'screenfull';
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            dispalayName: '请登录',
            message: 0,
            timer: null,
            operateName: ' 请登录',
            menuBarBackgroundColor: '#000000',
            homePageBackgroundColor: '#999',
            websock: null,
            receiveData: []

        };
    },
    created() {
        this.initWebSocket() // 初始化weosocket，发起连接
        this.getSystemInfo();
        let username = JSON.parse(localStorage.getItem('ms_userInfo')).realName;
        this.dispalayName = username ? username : '请登录';
        this.operateName = username ? '退出登录' : '请登录';
    },
    mounted() {
        if (this.timer) {
            clearInterval(this.timer);
        } else {
            this.timer = setInterval(() => {
                this.sendMsg();
            }, 1000 * 2)
        }
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    },
    destroyed() {
        clearInterval(this.timer);
        if (this.websock) {
            this.websock.close() // 关闭websocket
        }
    },
    methods: {
        initWebSocket() {
            if (typeof (WebSocket) === "undefined") {
                alert("您的浏览器不支持WebSocket")
                return false
            }
            const wsuri = `ws://${window.location.hostname}:8085/websocket/getdata` // websocket地址
            this.websock = new WebSocket(wsuri)
            this.websock.onmessage = this.websocketonmessage
            this.websock.onerror = this.websocketonerror
        },
        //接收后端返回的数据
        websocketonmessage(e) {
            this.receiveData = JSON.parse(e.data);
            if (this.receiveData.MsgType == 0) {
                this.message = parseInt(this.receiveData.Message);
            } else {
                this.notification(this.receiveData.Message);
            }
        },
        //连接建立失败重连
        websocketonerror(e) {
            this.initWebSocket() // 连接失败后尝试重新连接
        },
        sendMsg() {
            if (this.websock.readyState === 1) {
                // 把后台需要的参数数据传过去
                let obj = {
                    token: 'xxxxx',
                    message: 'GetUnreadCount'
                }
                //发给后端的数据需要字符串化
                this.websock.send(JSON.stringify(obj))
            }
        },
        notification(msg) {
            let parts = msg.split(/(?<=【.*?】)/);
            this.$notify.info({
                title: parts[0],
                message: parts[1],
                position: 'bottom-right',
                duration: 0
            });
        },
        getNewMessage() {
            this.$zybhttp
                .get('DataInquiry/GetMessage')
                .then((res) => {
                    if (res.data.status == 0) {
                        this.message = res.data.data.total;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取消息中心列表失败！'));
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                let username = localStorage.getItem('ms_username');
                if (username) {
                    localStorage.removeItem('ms_username');
                    this.$router.go(0);
                } else {
                    // this.$router.push({ path: '/Login' });
                    localStorage.setItem('showLogin', 'yes');
                }
            }
            if (command == 'setting') {
                let username = localStorage.getItem('ms_username');
                if (username) {
                    this.$router.push({
                        path: '/PersonInfo'
                    });
                }
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            // 找到要放大得页面
            let fullDiv = document.getElementById("fullDiv");
            if (fullDiv) {
                //找到后调用自带的toggle事件进行放大操作
                // fullDiv.style.backgroundColor = this.homePageBackgroundColor;
                fullDiv.style.backgroundColor = "#f0f0f0";
                screenfull.toggle(fullDiv);
            } else {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
            }

            this.fullscreen = !this.fullscreen;
        },
        getSystemInfo() {
            this.$zybhttp.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}` //设置token
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
                        this.homePageBackgroundColor = d.data.list[0].homePageBackgroundColor;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
    }
};
</script>

<style scoped>
[v-cloak] {
    display: none;
}

.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    font-size: 22px;
    color: #fff;
    background-color: black;
}

.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 50px;
}

.header .logo {
    float: left;
    width: 250px;
    line-height: 50px;
}

.header-right {
    float: right;
    padding-right: 50px;
}

.header-user-con {
    display: flex;
    height: 50px;
    align-items: center;
}

.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    margin-left: 10px;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-menu__item {
    text-align: center;
}
</style>
